import React, { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus, decode_utf8, getPageLayoutType, getCurrentTime, getPathName } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";


export const GetCompensationContext = createContext();

export const ACTIONS = {
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_CURRENT_ARRAY: "SET_CURRENT_ARRAY",
  SET_RESPONSE_COMPENSATION: "SET_RESPONSE_COMPENSATION",
  SET_RESPONSE_RELIQUIDATION: "SET_RESPONSE_RELIQUIDATION",
  SET_LIST_CARTOLA_RELIQUIDATION: "SET_LIST_CARTOLA_RELIQUIDATION",
  SET_ERROR: "SET_ERROR",
  SET_IDLIST: "SET_IDLIST",
  SET_LOAD_PAGE: "SET_LOAD_PAGE", 
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_TAG: "SET_TAG",

};

const initialState = {
  idCliente: '',
  currentArrayYearClientId:[],
  responseCompensation: {},
  responseReliquidation: {},
  listCartolaReliquidation: {},
  errorFetch: null,
  idList: [],
  loadPage: false,
  webContentTextInfo: "",
  tag: ""

};

const GetCompensationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idCliente: action.payload,
      };
    }
    case ACTIONS.SET_CURRENT_ARRAY: {
      return {
        ...state,
        currentArrayYearClientId: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_COMPENSATION: {
      return {
        ...state,
        responseCompensation: action.payload,
      };
    }    
    case ACTIONS.SET_RESPONSE_RELIQUIDATION: {
      return {
        ...state,
        responseReliquidation: action.payload,
      };
    }
    case ACTIONS.SET_LIST_CARTOLA_RELIQUIDATION: {
      return {
        ...state,
        listCartolaReliquidation: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_LOAD_PAGE: {
      return {
        ...state,
        loadPage: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_TAG: {
      return {
        ...state,
        tag: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

const GetCompensationContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);
  const [state, dispatch] = useReducer(GetCompensationReducer, initialState);
  const { accessToken } = useContext(AccessTokenContext);

  useEffect(() => {

    if(accessToken){
      LiferayService.getIdList(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_IDLIST,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      })
    }
  },[accessToken])

  useEffect(() => {
    if (state.loadPage) {
      if(getPathName() === 'cartola-de-reliquidacion'|| getPathName() === 'cartola-de-reliquidacion-y-compensacion'){
        LiferayService.getListaCartolaReliquidation(properties.base_url_api, properties.url_ws_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_LIST_CARTOLA_RELIQUIDATION,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
        })
      }
    if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
      dispatch({
        payload: false,
        type: ACTIONS.SET_LOAD_PAGE,
      });
    }
  }, [state.loadPage]);
  
  React.useEffect(() => {
    if(state.tag){
      if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
        LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
        }
        dispatch({
          payload: "",
          type: ACTIONS.SET_TAG,
        });
    }
  },[state.tag])

  useEffect(() => {
    if(state.currentArrayYearClientId.length === 2 && (getPathName() === 'cartola-de-compensacion' || getPathName() === 'cartola-de-reliquidacion-y-compensacion')){
      LiferayService.getCompensation(properties.base_url_api,state.currentArrayYearClientId[0], properties.codigo_empresa, properties.url_ws_empresa, state.currentArrayYearClientId[1], getSignedIdStatus())
      .then((response) => {
        if(!response.status){
          const blob = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.download = `CartolaCompensacion_${getCurrentTime()}.pdf`;
          link.href = fileURL;
          link.click();
        }

        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_COMPENSATION,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
      })
    .catch((error) => {
      dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
      });
      dispatch({
        payload: {},
        type: ACTIONS.SET_RESPONSE_COMPENSATION,
      });
      })
    }
    if(state.currentArrayYearClientId.length === 3 && (getPathName() === 'cartola-de-reliquidacion'|| getPathName() === 'cartola-de-reliquidacion-y-compensacion')){
      LiferayService.getReliquidation(properties.base_url_api,state.currentArrayYearClientId[0], state.currentArrayYearClientId[1], state.currentArrayYearClientId[2], properties.codigo_empresa, properties.url_ws_empresa, getSignedIdStatus(), decode_utf8(properties.rel_12_2014))
      .then((response) => {
        if(!response.status) {

          response.data.blob().then(blob => {
            const fileURL = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.download = `CartolaReliquidacion_${getCurrentTime()}.pdf`;
            link.href = fileURL;
            link.click();
          });
        }
        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_RELIQUIDATION,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
      })
    .catch((error) => {
      dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
      });
      dispatch({
        payload: {},
        type: ACTIONS.SET_RESPONSE_RELIQUIDATION,
      });
      })
    }
  }, [state.currentArrayYearClientId])

  return (
    <GetCompensationContext.Provider value={[state, dispatch]}>
      {children}
    </GetCompensationContext.Provider>
  );
};
export default GetCompensationContextProvider;
